export default "__VITE_ASSET__Df_cBU7H__"